/**
 * Created by tofael on 3/22/17.
 */
import React from 'react';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import api from '../utility/api';
import Logo from '../screens/shared/logo';
import { setUser } from '../actions/user';
import { setAuthUser } from '../utility/local-storage';
import ProgressBar from '../screens/layout/progressbar';
import { asyncStart, asyncEnd } from '../actions/application';

const styles = {
  formTitleBG:{
    backgroundColor:'#37a056'
  },
  formTitle: {
    textAlign: 'center',
    padding:'10px',
    color:'#ffffff',
    margin:0
  },
  feedbackMessage: {
    textAlign: 'center',
    color:'#3c7fa0',
    marginTop:'10px'
  },
  formBg: {
    backgroundColor: '#fff',
    borderRadius:'1%',
    overflow:'hidden',
    position: 'relative',
    marginBottom: '24px',
    boxShadow: '0 5px 5px 0 rgba(0,0,0,.25)',
  }
};

class Login extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      username: '',
      password: '',
      error: ''
    };
  }

  handleChange(field, e) {
    this.setState({[field]: e.target.value});
  }

  dispatch(action){
    this.props.dispatch(action());
  }

  handleSubmit(e) {
    e.preventDefault();
    this.dispatch(asyncStart);
    let {username, password} = this.state;
    api.login(username, password)
      .then(data => {
        let {user} = data;
        setAuthUser(data);
        this.dispatch(asyncEnd);
        this.dispatch(setUser.bind(null,user));

        const location = this.props.location;
        if (location.state && location.state.nextPathname) {
          let previousUrl = location.state.nextPathname;
          hashHistory.push(decodeURIComponent(previousUrl));
        } else {
          hashHistory.push('doctors');
        }
      })
      .catch(error => {
        this.setState({username:'',password:'',error:error.message});
        this.dispatch(asyncEnd);
      });

  }

  render() {
    const showLoader = this.props.isLoading;
    return (
      <div>
        <ProgressBar
          open={showLoader}
        />
        <Logo/>
        <div style={styles.formBg} className="login-form-wrapper">
          <div style={styles.formTitleBG}><h1 style={styles.formTitle}>Login</h1></div>
          <div style={styles.feedbackMessage}>{this.state.error}</div>
          <form onSubmit={this.handleSubmit.bind(this)}>
            <TextField
              hintText="username"
              floatingLabelText="Username"
              autoFocus={true}
              required={true}
              value={this.state.username}
              className="form-input-wrapper"
              onChange={this.handleChange.bind(this, 'username')}
            /><br/>
            <TextField
              hintText=""
              floatingLabelText="Password"
              type="password"
              required={true}
              value={this.state.password}
              className="form-input-wrapper"
              onChange={this.handleChange.bind(this, 'password')}
            /><br/>
            <RaisedButton
              label="Login"
              type="submit"
              className="form-input-wrapper login-button"
              disabled={this.props.isLoading}
            /><br/>
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state.application;
}

export default connect(mapStateToProps, null)(Login);



// WEBPACK FOOTER //
// ./src/containers/login.js